"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const h = React.createElement;
const className = (0, nano_theme_1.rule)({
    d: 'flex',
    w: '100%',
});
const Flex = ({ as = 'div', children, ...rest }) => {
    rest.className = (rest.className || '') + className;
    return Array.isArray(children) ? h(as, rest, ...children) : h(as, rest, children);
};
exports.Flex = Flex;
